import type { ReactElement } from 'react';
import { formatMmSsFromMs } from '@/lib/format-time';
import { cn } from '@/lib/cn';

export type FloatingRecorderPillProps = {
  status: 'recording' | 'paused';
  elapsedMs: number;
  onReturn: () => void;
};

export function FloatingRecorderPill({
  status,
  elapsedMs,
  onReturn,
}: FloatingRecorderPillProps): ReactElement {
  const label = status === 'recording' ? 'recording' : 'paused';
  return (
    <button
      type="button"
      aria-label="Return to recording"
      onClick={onReturn}
      className={cn(
        'fixed bottom-20 right-4 z-[65] inline-flex items-center gap-2 rounded-full px-4 py-2',
        'bg-[var(--ink)] text-[var(--bg-surface)] shadow-2xl',
        'md:bottom-6',
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'h-2 w-2 rounded-full bg-[var(--err)]',
          status === 'recording' && 'animate-pulse',
        )}
      />
      <span className="font-mono text-xs tabular-nums">{formatMmSsFromMs(elapsedMs)}</span>
      <span className="text-xs opacity-80">{label}</span>
    </button>
  );
}
